<span (click)="setSelectedBadge(handle);"
      [class.bg-light]="(selectedBadge | async) && (selectedBadge | async) !== handle"
      class="{{'badge bg-'+style}} d-print-none">{{ text }}</span>
